import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import RtlLayout from "layouts/rtl";
import AdminLayout from "components/Layout/AdminLayout";
import AuthLayout from "layouts/auth";
import AddUser from "components/User/Adduser";
import Login from "components/User/Login.jsx";
import AddInspection from "components/Inspection/AddInspection.jsx";
import AddFile from "components/File/AddFile.jsx";
import MainDashboard from "./views/admin/default/index.jsx";
import ViewTraders from "./components/Traders/ViewTrader.jsx";
import ViewInspection from "./components/Inspection/ViewInspection.jsx";
import ForgotPassword from "components/User/ForgotPassword.jsx";
import AddTrader from "./components/Traders/AddTrader.jsx";
import ViewUser from "./components/User/ViewUser.jsx";
import ViewFile from "./components/File/ViewFile.jsx";
import ViewInspectors from "components/Inspectors/ViewInspectors";
import ViewCompliance from "components/Compliance/ViewCompliance";
import AddCompliance from "components/Compliance/AddCompliance.jsx";
import InspectorViewtrader from "components/Traders/InspectorViewtrader.jsx";
import Userviewfile from "components/File/UserViewfile.jsx";
import InspectorViewfile from "components/File/InspectorViewfile.jsx";
import InspectorViewinspection from "components/Inspection/InspectorViewinspection.jsx";
import InspectorCompliance from 'components/Compliance/InspectorCompliance';
import UserCompliance from "components/Compliance/UserCompliance.jsx";
import UserInspection from "components/Inspection/UserInspection.jsx";
import InspectionPage from "components/Inspection/InspectionPage.jsx";
import ViewTrader from "components/Traders/ViewTrader.jsx";
import EditTrader from "components/Traders/EditTrader.jsx";
import InspectionDetail from "components/Inspection/InspectionDetail.jsx";
import AddInspectors from "./components/Inspectors/AddInspectors.jsx";
import TradersInspection from "components/Inspection/TradersInspection.jsx";

const App = () => {
    return (
        <Routes>
            <Route path="/" element={<Login />} />
  <Route path="adduser" element={<AddUser />} />
            <Route path="auth/*" element={<AuthLayout />} />
<Route path="forgotpassword" element={<ForgotPassword/>}/>
            <Route path="admin/*" element={<AdminLayout />}>
                <Route index element={<MainDashboard />} />
                <Route path="userviewfile" element={<Userviewfile />} />
                <Route path="dashboard" element={<MainDashboard />} />
                <Route path="InspectorViewfile" element={<InspectorViewfile />} />
                <Route path="inspectiondetail" element={<InspectionDetail />} />
                <Route path="viewtrader" element={<ViewTrader />} />
                <Route path="InspectorViewtrader" element={<InspectorViewtrader />} />
                <Route path="addinspector" element={<AddInspectors />} />
                <Route path="payments" element={<ViewInspection />} />
                <Route path="traders/edit/:id" element={<EditTrader />} />
                <Route path="viewinspectors" element={<ViewInspectors />} />
                <Route path="UserInspection" element={<UserInspection />} />
                <Route path="traderinspection" element={<TradersInspection/>}/>
                <Route path="insepectorcomliance" element={<InspectorCompliance />} />
                <Route path="inspectorviewinspection" element={<InspectorViewinspection />} />
              
                <Route path="viewinspection" element={<ViewInspection />} />
                <Route path="inspectionpage" element={<InspectionPage />} />
                <Route path="viewuser" element={<ViewUser />} />
                <Route path="UserCompliance" element={<UserCompliance />} />
                <Route path="viewcompliance" element={<ViewCompliance />} />
                <Route path="addcompliance" element={<AddCompliance />} />
                <Route path="addfile" element={<AddFile />} />
                <Route path="tradxers" element={<ViewTraders />} />
                <Route path="addtrader" element={<AddTrader />} />
              
                <Route path="viewfile" element={<ViewFile />} />
                <Route
                    path="InspectorViewtrader"
                    element={<InspectorViewtrader />}
                />

                <Route path="addinspection" element={<AddInspection />} />
            </Route>

            <Route path="rtl/*" element={<RtlLayout />} />
        </Routes>
    );
};

export default App;
